import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { AccidentsComponent } from './accidents.component';
import { AccidentsFiltersComponent } from './accidents-filters/accidents-filters.component';

import { ListService } from '../list.service';

import { AngularMaterialModule } from '../angular-material.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AngularMaterialModule
  ],
  providers: [
    AccidentsFiltersComponent,
    ListService
  ],
  declarations: [
    AccidentsComponent,
    AccidentsFiltersComponent
  ],
  exports: [
    AccidentsComponent
  ]
})

export class AccidentsModule { }
